import { Button } from "@mantine/core";
import React from "react";

function SubmitButton() {
  return (
    <Button className="bg-yellow-400 hover:bg-yellow-300 text-black px-6 py-2 rounded-full">
      Submit
    </Button>
  );
}

export default SubmitButton;
